module.exports = __webpack_public_path__ + "img/스내쳐.c9842584.png";